import { render, staticRenderFns } from "./KnowledgeStatistics.vue?vue&type=template&id=a3e6b66a&scoped=true&"
import script from "./KnowledgeStatistics.vue?vue&type=script&lang=js&"
export * from "./KnowledgeStatistics.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeStatistics.vue?vue&type=style&index=0&id=a3e6b66a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e6b66a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
